import { JsonPipe, NgIf } from '@angular/common';
import { Component, inject, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from '../ag-grid-list/ag-grid-list.component';
import { BulkUploadComponent } from '../bulk-upload/bulk-upload.component';
import { ButtonComponent } from '../button/button.component';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { DateInputComponent } from '../date-input/date-input.component';
import { HeaderComponent } from '../header/header.component';
import { ImageUploderComponent } from '../image-uploder/image-uploder.component';
import { ModalComponent } from '../modal/modal.component';
import { SearchInputComponent } from '../search-input/search-input.component';
import { SelectInputComponent } from '../select-input/select-input.component';
import { TextInputComponent } from '../text-input/text-input.component';
import { ListActionButtonsComponent } from '../list-action-buttons/list-action-buttons.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownService } from '../../services/dropdown.service';
import { FormService } from '../../services/form.service';
import { GlobalService } from '../../services/global.service';
import { UserService } from '../../services/user.service';
import { ValidationService } from '../../services/validation.service';
import { min } from 'date-fns';
import { DropdownUploadButtonComponent } from '../dropdown-upload-button/dropdown-upload-button.component';

@Component({
  selector: 'app-student-user',
  imports: [HeaderComponent, SearchInputComponent, JsonPipe, NgIf, ButtonComponent, FilterByKeyAndValuePipe, AgGridListComponent, ConfirmationPopupComponent, ModalComponent, TextInputComponent, BulkUploadComponent, ReactiveFormsModule, PluralPipe, FormsModule, SelectInputComponent, NgIf, ImageUploderComponent, DateInputComponent, DropdownUploadButtonComponent],
  templateUrl: './student-user.component.html',
  styleUrl: './student-user.component.css'
})
export class StudentUserComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  page_name = 'User';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any = [];
  fs = inject(FormService);
  showPasswordField: boolean = true;
  show_menu = false;


  columns: any = [];

  bulk_columns = [
    // { column_name: 'Roll Number', type: 'text', return_as: 'roll_number', sample_value: '123' },
    // { column_name: 'Date of Birth', type: 'text', return_as: 'birth_date', sample_value: '01-02-2001' },
    { column_name: 'Registration Number', type: 'text', return_as: 'registration_number', sample_value: '121' },
    { column_name: 'Name', type: 'text', return_as: 'name', sample_value: 'test', skip_validation: true, regex: this.vs.new_name_pattern, min_length: this.vs.min_length_name, max_length: this.vs.max_length_name, },
    { column_name: 'Email', type: 'text', return_as: 'email', sample_value: 'Mumbai@gmail.com', skip_validation: true },
    { column_name: 'Contact', type: 'text', return_as: 'contact', sample_value: '1210100121', skip_validation: true, regex: /^\d+$/, min_length: this.vs.min_length_contact, max_length: this.vs.max_length_contact },
    { column_name: 'Password', type: 'text', return_as: 'password', sample_value: 'Admin@123', skip_validation: true },
  ];

  bulk_columns_download: any = [];

  bulk_form: FormGroup = this.fb.group({
    university_id: ['', Validators.required],
    academic_year_id: ['', Validators.required],
  });

  filteredBulkAcademicYears: any[] = [];

  onBulkUniversityChange(event: any) {
    this.bulk_form.patchValue({ academic_year_id: '' });
    const university_id = event?.value?.value;
    if (!university_id) {
      this.filteredBulkAcademicYears = [];
      return;
    }
    const academic_year_ids = (this.ds.dropdown_list?.exam_list || [])
      .filter((e: any) => e.university_id == university_id)
      .map((e: any) => e.academic_year_id || e.AcademicYear?.id)
      .filter((id: any, i: number, self: any[]) => id && self.indexOf(id) === i);
    this.filteredBulkAcademicYears = (this.ds.dropdown_list?.academic_list || [])
      .filter((a: any) => academic_year_ids.includes(a.id));
  }

  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.user_management_students_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.user_management_students_view })
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.user_management_students_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete.bind(this), permissions: this.gs.user_role_data?.user_management_students_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public us: UserService, public ar: ActivatedRoute, public ds: DropdownService, public vs: ValidationService) {
    this.form = this.fb.group({
      role_id: [''],
      university_id: ['', [Validators.required]],
      academic_year_id: ['', [Validators.required]],
      // exam_id: ['', [Validators.required]],
      // roll_number: ['', [Validators.required, Validators.pattern(this.vs.code_pattern)]],
      // birth_date: ['', [Validators.required]],
      registration_number: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9-]+$/)]],
      first_name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.new_name_pattern)]],
      last_name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.new_name_pattern)]],
      contact: [null, [Validators.minLength(this.vs.min_length_contact), Validators.maxLength(this.vs.max_length_contact)]],
      email: ['', [Validators.required, Validators.pattern(this.vs.email_pattern), Validators.maxLength(this.vs.max_length_email)]],
      password: ['', [Validators.required, Validators.pattern(this.vs.password_complex_pattern)]],
      // image: [''],
      // college_id: [''],
      // subject_id: [''],
      is_active: [true],
      user_type: ''
    });
  }
  selectedRole: any = null;
  filter_params: any = {};

  onFilterChange(event: any, key: string) {
    if (event?.value) {
      this.filter_params[key] = event.value.value;
    } else {
      delete this.filter_params[key];
    }
    this.get_list({ ...this.params, ...this.filter_params });
  }

  getRowStyle = (params: any) => {
    if (params.data?.is_active === false) {
      return { background: '#F7F7F7', color: '#9ca3af' };
    }
    return null;
  };

  async ngOnInit() {
    await this.ds?.get_dropdown_list(['role', 'university', 'exam', 'subject', 'college', 'academic-year']);
    // set default role_id dynamically to the Role entry for students (if available)
    // try {
    //   const studentRole = this.ds.dropdown_list?.role_list?.find((r: any) => (r.title || '').toString().toLowerCase().includes('student'))?.value;
    //   if (studentRole) {
    //     // only set default when creating new user (i.e., no selected_ids/user present)
    //     if (!this.selected_ids || Object.keys(this.selected_ids).length === 0) {
    //       this.form.patchValue({ role_id: studentRole });
    //     }
    //   }
    // } catch (e) {
    //   // ignore if dropdowns or structure not present
    // }
    this.ar.queryParams.subscribe(params => {
      this.params = { ...params, user_type: 'student' };
      this.page_name = 'Student';
      this.column_push()
      const user_type_params = { ...this.params, user_type: 'student' };
      this.get_list(user_type_params)
    });
  }

  column_push() {
    this.columns = [
      { field: 'registration_number', headerName: 'Unique ID', filter: true, flex: 1, },
      { field: 'name', headerName: 'Name', filter: true, flex: 1, },
      {
        headerName: 'Contact', filter: true, flex: 1,
        cellRenderer: (p: any) => {
          const contact = p.data?.contact ? `+91${p.data.contact}` : '';
          const email = p.data?.email || '';
          return `<div style="display:flex; flex-direction:column; justify-content:center; height:100%; line-height:1.4"><span style="font-weight:500; color:#1f2937; font-size:13px">${contact}</span><span style="color:#6b7280; font-size:12px">${email}</span></div>`;
        }
      },
      { headerName: "Actions", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', }
    ]

    this.bulk_columns_download = [
      // { column_name: 'Role No', type: 'text', return_as: 'roll_number', sample_value: '111' },
      // { column_name: 'Date of Birth', type: 'text', return_as: 'birth_date', sample_value: 'AD' },
      { column_name: 'Registration Number', type: 'text', return_as: 'registration_number', sample_value: 'AD' },
      { column_name: 'Name', type: 'text', return_as: 'name', sample_value: 'Mumbai' },
      { column_name: 'Email', type: 'text', return_as: 'email', sample_value: 'Mumbai@gmail.com' },
      { column_name: 'Contact', type: 'text', return_as: 'contact', sample_value: '123456' },
      // { column_name: 'Exam', download_bind: 'exam_id', type: 'link', linked_list: 'exam_list', linked_from: 'exam', return_as: 'exam_id', returning_key: 'id', sample_value: '1' },
      { column_name: 'AcademicYear', download_bind: 'academic_year_id', type: 'link', linked_list: 'academic_list', linked_from: 'academic-year', return_as: 'academic_year_id', returning_key: 'id', sample_value: '1' },
    ]
  }

  async get_list(filter?: any) {
    try {
      const finalFilter = { ...filter, user_type: 'student' };
      const res = await this.us.get_list(finalFilter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async disable(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_disabled_modal?.open();
  }

  async delete(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }

  async bulk_delete(ids: any[]) {
    try {
      for (let id of ids) {
        // const user_type = 'student';
        let res = await this.us.delete(id);
      }
      this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async open_form_modal(item?: any) {
    this.selected_ids = item || {};
    if (this.selected_ids && this.selected_ids?.id || this.selected_ids?.user?.id) {
      const user_type = 'student';
      let response = await this.us.get(this.selected_ids?.id);
      this.selected_ids = { ...response.data };
      const nameParts = (this.selected_ids.name || '').split(' ');
      this.form.patchValue({
        ...this.selected_ids,
        first_name: nameParts[0] || '',
        last_name: nameParts.slice(1).join(' ') || '',
      });
      // Hide password field for existing users
      this.showPasswordField = false;
      this.form.get('password')?.clearValidators();
      this.form.get('password')?.reset();
      this.form.get('password')?.updateValueAndValidity();
    } else {
      this.selected_ids = {};
      this.form.reset();
      // Show password field for new users
      this.showPasswordField = true;
      this.form.get('password')?.setValidators([
        Validators.required,
        Validators.pattern(this.vs.password_complex_pattern)
      ]);
      this.form.get('password')?.updateValueAndValidity();
    }
    this.form_modal?.open();
  }

  open_view_modal(item: any) {
    this.selected_ids = item || {};
    this.view_modal?.open();
  }

  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      console.log(item, 'aaaa');

      let data = item == true ? false : true;
      let update = await this.us.update(this.selected_ids?.id, { is_active: data, user_type: 'student' });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async disable_country() {
    try {
      let res = await this.us.delete(this.selected_ids?.id);
      if (res?.code === 200) {
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.selected_ids = {};
      this.confirmation_delete_modal?.close();
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message || 'Delete failed', 'Error', 'error');
    }
  }

  close_form_modal(): void {
    this.form_modal?.close();
  }

  async submit() {
    try {
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      let payload: any = { ...this.form.value, user_type: 'student', name: `${this.form.value.first_name} ${this.form.value.last_name}`.trim() };
      delete payload.first_name;
      delete payload.last_name;
      payload.user_type = 'student'

      // Get student role ID from dropdown service
      try {
        const studentRole = this.ds.dropdown_list?.role_list?.find((r: any) => (r.title || '').toString().toLowerCase().includes('student'));
        if (studentRole && studentRole.value) {
          payload.role_id = studentRole.value;
        }
      } catch (e) {
        console.warn('Could not find student role', e);
      }

      delete payload.image;
      payload.is_active = true;
      payload.subject_id = 1
      delete payload.subject_id
      if (this.selected_ids?.id) {
        // For update: only include password if user clicked "Reset Password" (showPasswordField = true)
        if (!this.showPasswordField) {
          delete payload.password;
        }
        let update_response = await this.us.update(this.selected_ids?.id, payload);
        this.gs.toastr_shows_function(update_response.message, 'Success', 'success');
      } else {
        let create_response = await this.us.add(payload);
        this.gs.toastr_shows_function('Student created successfully', 'Success', 'success');
      }
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');

    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      // Get student role ID from dropdown service
      let studentRoleId = null;
      try {
        const studentRole = this.ds.dropdown_list?.role_list?.find((r: any) => (r.title || '').toString().toLowerCase().includes('student'));
        if (studentRole && studentRole.value) {
          studentRoleId = studentRole.value;
        }
      } catch (e) {
        console.warn('Could not find student role', e);
      }

      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true,
        user_type: 'student',
        ...(studentRoleId && { role_id: studentRoleId })
      }));
      console.log(updatedData);
      await this.gs.bulk_form_submission(updatedData, this.us, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  private formatDateToYYYYMMDD(dateStr: string): string {
    if (!dateStr) return dateStr;

    const parts = dateStr.split('-'); // dd-mm-yyyy
    if (parts.length !== 3) return dateStr;

    const [dd, mm, yyyy] = parts;
    return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
  }


  resetPassword() {
    this.showPasswordField = true;

    this.form.get('password')?.reset();
    this.form.get('password')?.setValidators([
      Validators.required,
      Validators.pattern(this.vs.password_complex_pattern)
    ]);
    this.form.get('password')?.updateValueAndValidity();
  }

  hidePassword() {
    this.showPasswordField = false;

    this.form.get('password')?.clearValidators();
    this.form.get('password')?.reset();
    this.form.get('password')?.updateValueAndValidity();
  }
}
